
import Home01 from './Home01';
import Home02 from './Home02';
import Home03 from './Home03';
import HomeOnePage from './HomeOnePage';
import AboutUs from './AboutUs';
import Collections from './Collections';
import Team from './Team';
import RoadMap from './RoadMap';
import BlogList from './BlogList';
import BlogGrid from './BlogGrid';
import BlogSingle from './BlogSingle';
import FAQ from './FAQ';
import Contact from './Contact';
import OurMission from './OurMission';
import MyHistoryStudio from './MyHistoryStudio';

const routes = [
  { path: '/', component: <Home01 />},
  { path: '/home-02', component: <Home02 />},
  { path: '/home-03', component: <Home03 />},
  { path: '/home-one-page', component: <HomeOnePage />},
  { path: '/about', component: <AboutUs />},
  { path: '/photo', component: <Collections />},
  { path: '/team', component: <Team />},
  { path: '/webgfx', component: <RoadMap />},
  { path: '/my-history-studio', component: <OurMission />},
  { path: '/my-history-studio/process', component: <MyHistoryStudio />},
  { path: '/blog-list', component: <BlogList />},
  { path: '/video', component: <BlogGrid />},
  { path: '/blog-single', component: <BlogSingle />},
  { path: '/web', component: <FAQ />},
  { path: '/contact', component: <Contact />},
]

export default routes;